import { Typography } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'

import useStyles from './styles/RateplansTable.styles'

const RateplanRowMobileSkeleton: React.FC = () => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.tableRowMobile}>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
        <div>
          <Typography variant="body1">
            <Skeleton animation="wave" className={classes.skeleton} />
          </Typography>
        </div>
      </div>
    </>
  )
}

export default RateplanRowMobileSkeleton
